import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activityNotesData: [],
  filteredActivityNotes: [],
  allLabels: [],
  singleNoteData:[],
  selectedNotetitle: null, // filtering
  selectedAssets: [], // filtering
  selectedStakeholders: [], // filtering
  selectedNoteDate: null, // filtering
  selectedLabels: [], // filtering
  allDimensions: [],
  page: 1,
  rowsPerPage: 10,
  sort: {
    keytoSort: 'modified',
    direction: 'desc',
  },
};


const activityNotesSlice = createSlice({
  name: "activityNotes",
  initialState,
  reducers:{
    setActivityNotesData: (state, action) => {
      state.activityNotesData = action.payload;
    },
    setFilteredActivityNotes: (state, action) => {
      state.filteredActivityNotes = action.payload;
    },
    setAllLabels: (state, action) => {
      state.allLabels = action.payload;
    },
    setSingleNoteData: (state, action) => {
      state.singleNoteData = action.payload;
    },
    setSelectedNotetitle: (state, action) => {
      state.selectedNotetitle = action.payload;
    },
    setSelectedAssets: (state, action) => {
      state.selectedAssets = action.payload;
    },
    setSelectedStakeholders: (state, action) => {
      state.selectedStakeholders = action.payload;
    },
    setSelectedNoteDate: (state, action) => {
      state.selectedNoteDate = action.payload;
    },
    setSelectedLabels: (state, action) => {
      state.selectedLabels = action.payload;
    },
    setAllDimensions: (state, action) => {
      state.allDimensions = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
  },
});

export const {
  setActivityNotesData,
  setFilteredActivityNotes,
  setAllLabels,
  setAllDimensions,
  setSingleNoteData,
  setSelectedNotetitle,
  setSelectedAssets,
  setSelectedStakeholders,
  setSelectedNoteDate,
  setSelectedLabels,
  setPage,
  setRowsPerPage,
  setSort
} = activityNotesSlice.actions;

export default activityNotesSlice.reducer;
